import React from 'react'
import _, { find } from 'lodash'
import Select from 'react-select'
import {
  ButtonContainer,
  Button,
  FormInputTextArea,
  Alert,
  FormInput,
  FormInputSelect,
  Row,
  Col
} from 'camino-react'

import Modal from 'Components/Modal'

const EditModal = ({
  showEditModal,
  setEditModalVisible,
  errorMessage,
  priority,
  handlePriorityChange,
  setFieldErrorClasses,
  fields,
  errors,
  handleInput,
  submit,
  submitButton,
  priorities,
  categories,
  datacentres,
  majorIncidentManagers,
  managers,
  usersOptions,
  technicalEngineers,
  handleMultiSelect,
  problem_manager_id
}) => {
  const detailFields = [
    {
      value: 'issue',
      label: 'Issue'
    },
    {
      value: 'root_cause',
      label: 'Root cause'
    },
    {
      value: 'business_impact',
      label: 'Business impact'
    },
    {
      value: 'corrective_action',
      label: 'Corrective action'
    },
    {
      value: 'preventive_action',
      label: 'Preventive action'
    },
    {
      value: 'outcome',
      label: 'Outcome'
    }
  ]
  const priorityPivots = _.map(priorities, priorityPivot => (
    { key: priorityPivot, value: _.capitalize(priorityPivot), label: `${_.capitalize(priorityPivot)}` }
  ))

  return (
    <Modal showModal={showEditModal} title="Edit problem" removeModal={() => setEditModalVisible(false)}>
      {errorMessage && (
        <Alert type="error">
          {errorMessage}
        </Alert>
      )}
      <div>
        <FormInput label="Priority">
          <Select
            value={priority}
            onChange={(e) => { handlePriorityChange(e) }}
            options={priorityPivots}
            searchable={false}
            clearable={false}
            className={setFieldErrorClasses('priority')}
          />
        </FormInput>
        <FormInput label="Category">
          <Select
            value={find(categories, { value: fields.category_id })}
            onChange={(e) => { handleInput('category_id', e.value) }}
            options={categories}
            searchable={false}
            clearable={false}
          />
        </FormInput>
        <FormInput label="Datacentre Location">
          <Select
            value={find(datacentres, { value: fields.datacentre_id })}
            onChange={(e) => { handleInput('datacentre_id', e.value) }}
            options={datacentres}
            searchable={false}
            clearable={false}
          />
        </FormInput>
        <FormInput label="Major Incident Manager">
          <Select
            value={find(majorIncidentManagers, { value: fields.major_incident_manager_id })}
            onChange={(e) => { handleInput('major_incident_manager_id', e.value) }}
            options={majorIncidentManagers}
            searchable={false}
            clearable={false}
          />
        </FormInput>
        <FormInput label="Problem Manager">
          <FormInputSelect
            value={find(managers, { value: fields.problem_manager_id })}
            options={managers}
            onValue={value => (handleInput('problem_manager_id', value))}
          />
        </FormInput>
        <FormInput label="Technical Engineers">
          <FormInputSelect
            isMulti
            value={technicalEngineers}
            options={usersOptions}
            onValue={value => handleMultiSelect('technicalEngineers', value)}
          />
        </FormInput>
      </div>

      {_.map(detailFields, ({ label, value: fieldName }, index) => (
        <FormInput label={label}>
          <FormInputTextArea
            value={fields[fieldName]}
            errors={errors[fieldName]}
            onValue={v => handleInput(fieldName, v)}
            rows="5"
          />
        </FormInput>
      ))}

      <ButtonContainer center spaced>
        <Button outline onClick={() => setEditModalVisible(false)}>
          Cancel
        </Button>
        <Button onClick={() => { submit() }} disabled={submitButton.disabled}>
          {submitButton.text}
        </Button>
      </ButtonContainer>
    </Modal>
  )
}

export default EditModal
